/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_NoteInputs */

const en_settings_cancel_note = /** @type {(inputs: Settings_Cancel_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything else? (optional)`)
};

const id_settings_cancel_note = /** @type {(inputs: Settings_Cancel_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada lagi? (opsional)`)
};

/**
* | output |
* | --- |
* | "Anything else? (optional)" |
*
* @param {Settings_Cancel_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_note = /** @type {((inputs?: Settings_Cancel_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_note(inputs)
	return en_settings_cancel_note(inputs)
});